/**
 * Os desenhos, um traço só para todas as plataformas.
 *
 * Estavam dentro do `Icone.tsx` do site. Saíram de lá quando o celular chegou:
 * a mesma lista escrita duas vezes envelhece torta, e um coração que muda no
 * navegador e não no telefone é exatamente o tipo de diferença que ninguém vê
 * até estar na frente dos dois aparelhos.
 *
 * Todos cabem em `0 0 24 24`, são contornados (`stroke`) com traço de 1,6 e
 * ponta redonda. Um pedaço de comprimento zero — `M12 17.5v.01` — vira um
 * ponto: é assim que o aviso ganha o pingo embaixo da exclamação.
 */

export type NomeDoIcone =
  | 'casa'
  | 'cinema'
  | 'kovu'
  | 'nota'
  | 'coracao'
  | 'coracao-partido'
  | 'estrela'
  | 'marco'
  | 'desejo'
  | 'ajustes'
  | 'mais'
  | 'lixo'
  | 'busca'
  | 'fechar'
  | 'voltar'
  | 'adiante'
  | 'enviar'
  | 'tranca'
  | 'aviso'
  | 'erro'
  | 'certo'
  | 'livro'
  | 'apagar'
  | 'calendario'
  | 'pessoas'
  | 'senha'
  | 'mala'
  | 'aviao'
  | 'teatro'
  | 'comida'
  | 'montanha'
  | 'dado'
  | 'nuvem-cortada'
  | 'geladeira'
  | 'carrinho'
  | 'elo'
  | 'elo-mais'
  | 'lapis'
  | 'avancar'
  | 'brilho'
  | 'voz'
  | 'relogio'
  | 'menos'
  | 'baixo'
  | 'cima'
  | 'recarregar'
  | 'abrir-fora'
  | 'carrinho-cortado'
  | 'calendario-certo'
  | 'grade'
  | 'retroceder'
  | 'toque'
  | 'calendario-vazio'
  | 'semana'
  | 'mais-circulo'
  | 'fotos'
  | 'foto-mais'
  | 'foto-quebrada'
  | 'tocar'
  | 'pausar'
  | 'tocar-circulo'
  | 'info'
  | 'mudo'
  | 'som'
  | 'tv-ao-vivo'
  | 'sinal'
  | 'pasta'
  | 'fila'
  | 'marcador'
  | 'conta'
  | 'busca-cortada'
  | 'servidor'
  | 'balao'
  | 'camera'
  | 'camera-cortada'
  | 'microfone'
  | 'microfone-cortado'
  | 'desligar'
  | 'trocar'
  | 'tela-cheia'
  | 'baixar-circulo'
  | 'fonte'
  | 'camadas'
  | 'expandir'
  | 'recolher'
  | 'lista'
  | 'lista-certa'
  | 'fila-certa'
  | 'elo-cortado'
  | 'partilhar'
  | 'certo-circulo'
  | 'arroba'
  | 'nota-lapis'
  | 'olho'
  | 'radio'
  | 'radio-marcado'
  | 'tv'
  | 'busca-mundo'
  | 'chama'
  | 'trofeu'
  | 'foguete'
  | 'pilha'
  | 'bussola'
  | 'lua'
  | 'pdf'
  | 'artigo'
  | 'celular'
  | 'globo'
  | 'fones'
  | 'fones-cortados'
  | 'livro-aberto'
  | 'partilhar-pontos'
  | 'baixar'
  | 'repetir'
  | 'biblioteca'
  | 'pular-atras'
  | 'pular-adiante'
  | 'correr-atras'
  | 'correr-adiante'
  | 'parar'
  | 'letra-menor'
  | 'letra-maior'
  | 'onda'
  | 'pincel'
  | 'borracha'
  | 'texto'
  | 'desfazer'
  | 'refazer'
  | 'banco'
  | 'chave'
  | 'frasco'
  | 'carta'
  | 'carta-aberta'
  | 'calendario-lapis'
  | 'amanhecer'
  | 'mente'
  | 'quiz'
  | 'alfinete'
  | 'flor'
  | 'xis-circulo'
  | 'sair'
  | 'paleta'
  | 'sino'
  | 'sino-cortado'
  | 'pessoa-mais'
  | 'pessoa-menos'
  | 'digital'
  | 'escudo-mais'
  | 'tranca-aberta'
  | 'maos'
  | 'controle'
  | 'raquete'
  | 'girar'
  | 'nota-musical'
  | 'embaralhar'
  | 'podio'
  | 'historico'
  | 'medalha'
  | 'raio'
  | 'linha-do-tempo'
  | 'folha'
  | 'peixe'
  | 'pao'
  | 'leite'
  | 'lata'
  | 'floco'
  | 'garrafa'
  | 'borrifador'
  | 'sabonete'
  | 'xicara'
  | 'sanduiche';

export const DESENHOS: Record<NomeDoIcone, string> = {
  casa: 'M3 10.5 12 3l9 7.5M5 9.5V21h14V9.5',
  cinema: 'M4 4h16v16H4zM4 9h16M4 15h16M9 4v16M15 4v16',
  kovu: 'M21 12a8 8 0 0 1-8 8H4l2.3-2.3A8 8 0 1 1 21 12z',
  nota: 'M5 3h9l5 5v13H5zM14 3v5h5M8 13h8M8 17h5',
  coracao:
    'M12 20.5s-7.5-4.6-7.5-9.7A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 3.2c0 5.1-7.5 9.7-7.5 9.7z',
  /* `Icons.heart_broken_rounded`: o mesmo coração com a racha no meio. */
  'coracao-partido':
    'M12 20.5s-7.5-4.6-7.5-9.7A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 3.2c0 5.1-7.5 9.7-7.5 9.7zM12 7.6 10 11.4l3.2 1.4-2.2 3 1 4.7',
  estrela: 'm12 3.5 2.6 5.6 6 .8-4.4 4.2 1.1 6.1-5.3-3-5.3 3 1.1-6.1L3.4 9.9l6-.8z',
  marco: 'M6 21V4M6 4h11l-2.5 3.5L17 11H6',
  desejo: 'M4 6h16M4 12h16M4 18h10M18.5 16.5l1.5 1.5 3-3',
  ajustes: 'M4 7h9M17 7h3M4 17h3M11 17h9M15 4v6M7 14v6',
  mais: 'M12 5v14M5 12h14',
  lixo: 'M4 7h16M10 7V4h4v3M6 7l1 13h10l1-13M10 11v6M14 11v6',
  busca: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.3-4.3',
  fechar: 'M6 6l12 12M18 6 6 18',
  voltar: 'M19 12H5M11 6l-6 6 6 6',
  /* `Icons.arrow_forward_rounded`: o `voltar` espelhado. O `avancar` é só a
     seta sem haste, e a tarja da sessão pede a haste inteira. */
  adiante: 'M5 12h14M13 6l6 6-6 6',
  enviar: 'M4 12 21 4l-8 17-1.8-7.2z',
  tranca: 'M6 11h12v9H6zM9 11V8a3 3 0 0 1 6 0v3',
  aviso: 'M12 4 2.5 20h19zM12 10v4M12 17.5v.01',
  /* `Icons.error_outline_rounded`. É o irmão redondo do `aviso`: o triângulo
     alerta antes, o círculo conta o que já deu errado. */
  erro: 'M12 3.2a8.8 8.8 0 1 0 0 17.6a8.8 8.8 0 0 0 0-17.6M12 7.6v5.2M12 16.2v.01',
  certo: 'M4 12.5 9.5 18 20 6.5',
  livro: 'M4 4.5h7a2 2 0 0 1 2 2V21a2 2 0 0 0-2-2H4zM20 4.5h-7a2 2 0 0 0-2 2V21a2 2 0 0 1 2-2h7z',
  apagar: 'M9.4 5H20a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9.4L3 12zM12 9.5l5 5M17 9.5l-5 5',
  calendario: 'M4 6h16v15H4zM4 10.5h16M8.5 3v4M15.5 3v4',
  pessoas:
    'M8.5 10.5a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8zM15.5 10.5a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8zM3.5 18v-1a3.2 3.2 0 0 1 3.2-3.2h1M20.5 18v-1a3.2 3.2 0 0 0-3.2-3.2h-1M12 21.5c-2.3-1.5-3.3-2.7-3.3-4a1.7 1.7 0 0 1 3.3-.9 1.7 1.7 0 0 1 3.3.9c0 1.3-1 2.5-3.3 4z',
  senha:
    'M3.5 7h17a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zM8 12v.01M12 12v.01M16 12v.01',
  mala: 'M3 8h18v12H3zM8 8V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V8M3 13.5h18',
  /* Os desenhos das categorias da lista de sonhos, na ordem do enum do
     Flutter: avião, teatro, comida, montanha, e depois `marco` e `estrela`,
     que já existiam. */
  aviao:
    'M12 2.8c1 0 1.6 1.2 1.6 3v3.4l7.4 4v2l-7.4-2.2v3.9l2.4 1.8v1.5L12 19.4l-4 1.8v-1.5l2.4-1.8V14L3 16.2v-2l7.4-4V5.8c0-1.8.6-3 1.6-3z',
  teatro:
    'M3.5 5h7v5.5a3.5 3.5 0 0 1-7 0zM13.5 5h7v5.5a3.5 3.5 0 0 1-7 0zM5.6 7.6v.01M8.4 7.6v.01M15.6 7.6v.01M18.4 7.6v.01M5.5 18.5c1.5 1.5 3 1.5 4.5 0M14 18.5c1.5 1.5 3 1.5 4.5 0',
  comida:
    'M6.5 3v7.5M4.5 3v4a2 2 0 0 0 4 0V3M6.5 10.5V21M17.5 3c-1.6 1.2-2.3 2.8-2.3 4.8 0 1.6.8 2.7 2.3 2.7M17.5 10.5V21',
  montanha: 'M2.5 19.5h19L13.2 5 9.4 11.6 7.4 9z',
  /* O dado é o `Icons.casino_rounded`, que é o botão de sortear uma estrela. */
  dado: 'M6.5 4h11a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-11A2.5 2.5 0 0 1 6.5 4zM8.5 8.5v.01M12 12v.01M15.5 15.5v.01',
  /* O `Icons.cloud_off_rounded` da porta sem servidor: lá a nuvem é cheia com
     um corte; aqui é a mesma nuvem contornada, com o risco por cima. */
  'nuvem-cortada':
    'M6.8 18.5h10.4a3.8 3.8 0 0 0 .3-7.38a5.5 5.5 0 0 0-10.5-1.6a4.6 4.6 0 0 0-.2 8.98M3.5 3.5 20.5 20.5',
  /* A cozinha: `Icons.kitchen_rounded` é a geladeira de duas portas, com o
     puxador de cada uma. É o desenho da despensa e do "guardar na despensa". */
  geladeira: 'M6 3h12v18H6zM6 10h12M9 6v2M9 13v3',
  /* `Icons.shopping_basket_rounded`: o cesto do mercado. */
  carrinho:
    'M3 8h18l-1.6 11.5a1.5 1.5 0 0 1-1.5 1.3H6.1a1.5 1.5 0 0 1-1.5-1.3zM8.5 8 12 3l3.5 5M9.5 12v4.5M14.5 12v4.5',
  /* `Icons.link_rounded`: os dois elos da corrente, para trazer de um site. */
  elo: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 1 0-5.7-5.7L11.4 6.9M14 10a4 4 0 0 0-5.7 0l-3 3A4 4 0 1 0 11 18.7l1.6-1.6',
  /* `Icons.add_link_rounded`: metade da corrente e o mais no lugar da outra
     metade — o elo que ainda não existe e vai ser criado. */
  'elo-mais': 'M11 7.5H8a4.5 4.5 0 0 0 0 9h3M8.5 12h4M17.5 9v6M14.5 12h6',
  /* `Icons.edit_rounded`: o lápis sobre a linha. */
  lapis: 'M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5 17zM14.5 5.5l4 4',
  /* `Icons.chevron_right_rounded`: o "tem mais aqui dentro". */
  avancar: 'm9.5 5.5 6.5 6.5-6.5 6.5',
  /* `Icons.auto_awesome_rounded`: o brilho de gerar a lista sozinha. */
  brilho:
    'm10 3 1.8 4.2L16 9l-4.2 1.8L10 15l-1.8-4.2L4 9l4.2-1.8zM17.5 14l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z',
  /* `Icons.record_voice_over_rounded`: a pessoa falando, para a Alexa. */
  voz: 'M9 11.5a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8zM2.5 20v-1.2A4.3 4.3 0 0 1 6.8 14.5h4.4a4.3 4.3 0 0 1 4.3 4.3V20M18 7.5a5 5 0 0 1 0 6M20.8 5a8.4 8.4 0 0 1 0 11',
  /* `Icons.schedule_rounded`: o relógio da validade que está perto. */
  relogio: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.2V12l3.2 2',
  /* O par do `mais`: `Icons.remove_rounded`, de tirar uma porção. */
  menos: 'M5 12h14',
  /* `Icons.south_rounded` e `Icons.north_rounded`: as duas direções da Alexa,
     trazer o que está lá e mandar o que falta. */
  baixo: 'M12 4v15M6 13.5l6 6 6-6',
  cima: 'M12 20V5M6 10.5l6-6 6 6',
  /* `Icons.refresh_rounded`: procurar de novo. */
  recarregar: 'M20 11.5A8 8 0 1 1 17.6 6M20 4v4.5h-4.5',
  /* `Icons.open_in_new_rounded`: sair desta tela para a de lá. */
  'abrir-fora':
    'M14 4h6v6M20 4l-8.5 8.5M18 14.5V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h4.5',
  /* `Icons.remove_shopping_cart_rounded`: a receita que ainda pede compra. */
  'carrinho-cortado':
    'M3 8h18l-1.6 11.5a1.5 1.5 0 0 1-1.5 1.3H6.1a1.5 1.5 0 0 1-1.5-1.3zM8.5 8 12 3l3.5 5M3.5 3.5l17 17',
  /* `Icons.event_available_rounded`: o calendário com o certo, de escolher a
     validade. Com data escolhida o desenho volta a ser o `calendario`, aceso. */
  'calendario-certo': 'M4 6h16v15H4zM4 10.5h16M8.5 3v4M15.5 3v4M9 15.5l2 2 4-4',
  /* `Icons.grid_view_rounded`: as quatro janelinhas do selo "acesso rápido". */
  grade: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  /* `Icons.chevron_left_rounded`: o par do `avancar`, para o mês que passou. */
  retroceder: 'm14.5 5.5-6.5 6.5 6.5 6.5',
  /* `Icons.touch_app_rounded`: o dedo do rodapé do calendário, o "toque em um
     dia". O dedo levantado e a mão fechada embaixo dele. */
  toque:
    'M9.5 11.5V5a1.5 1.5 0 0 1 3 0v6.5M12.5 11h3.3a2 2 0 0 1 2 2v2.5a5 5 0 0 1-5 5h-1.4a4 4 0 0 1-2.9-1.2L5 16a1.4 1.4 0 0 1 2-2l2.5 2',
  /* `Icons.event_busy_rounded`: o calendário com o risco, do dia sem nada. */
  'calendario-vazio':
    'M4 6h16v15H4zM4 10.5h16M8.5 3v4M15.5 3v4M9.8 14.3l4.4 4.4M14.2 14.3l-4.4 4.4',
  /* `Icons.calendar_view_week_rounded`: a semana em colunas, do cardápio. É
     outro desenho que o `calendario` de propósito — no Flutter o cardápio e o
     calendário têm ícones diferentes, e aqui os dois cabem na mesma grade de
     atalhos, então repetir o mesmo desenho confundiria os dois caminhos. */
  semana: 'M3.5 7h17v10h-17zM8 7v10M12 7v10M16 7v10',
  /* `Icons.add_circle_outline_rounded`: o mais dentro da roda, do convite das
     prévias vazias do painel — "planeje o próximo dia especial". É o `mais`
     com a roda em volta, e não o `mais` sozinho: nas prévias ele é o convite
     inteiro, sem botão embaixo para lhe dar contorno. */
  'mais-circulo': 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 8.5v7M8.5 12h7',
  /* O álbum: `Icons.photo_library_rounded` é uma foto sobre a outra. A de trás
     só mostra o canto, e a da frente traz o sol e o morro que dizem "imagem". */
  fotos: 'M8 3.5h12.5V16H8zM10.5 12.5l2.8-3 2.4 2.6 1.6-1.7 2.2 2.4M11.8 7.2v.01M4 7v13.5h13.5',
  /* O botão de guardar uma foto: `Icons.add_photo_alternate_rounded`. É a
     mesma foto, com o mais no lugar do canto que a moldura abre. */
  'foto-mais':
    'M19 11.5V19a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 3 19V6a1.5 1.5 0 0 1 1.5-1.5H12M5.8 17l3.4-4 2.9 3.4 2-2.2 2.9 2.8M19 3v6M16 6h6',
  /* Quando a imagem não vem: `Icons.broken_image_rounded`, a moldura rachada. */
  'foto-quebrada': 'M4 4.5h16v15H4zM4 13l3.5-3.5 2.5 2.5M14 19.5l1.5-4 4.5 2.5',

  /* ── Cinema ────────────────────────────────────────────────────────
     Os do cinema são `Icons.*_rounded` do Flutter. Continuam contornados
     como todos os outros: `preenchido` no `Icone` é que decide, e o botão
     "Assistir" do cartaz gigante é o único lugar que pede o triângulo
     cheio. */

  /* `Icons.play_arrow_rounded`. */
  tocar: 'M8 5.4v13.2L18.6 12z',
  /* `Icons.pause_rounded`. As duas barras nascem na mesma altura do triângulo
     do `tocar` para o botão não pular de tamanho ao trocar de estado. */
  pausar: 'M9 5.4h1.8v13.2H9zM13.2 5.4H15v13.2h-1.8z',
  /* `Icons.play_circle_fill_rounded`, o botão de retomar. */
  'tocar-circulo': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM10.3 8.4v7.2L16 12z',
  /* `Icons.info_outline`, o "Mais info". */
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5.5M12 7.5v.01',
  /* `Icons.volume_off_rounded`: o alto-falante com o X do lado. */
  mudo: 'M4 9.5h3.5L12 5.5v13L7.5 14.5H4zM16.5 9.5l4.5 5M21 9.5l-4.5 5',
  /* `Icons.volume_up_rounded`: as duas ondas saindo do alto-falante. */
  som: 'M4 9.5h3.5L12 5.5v13L7.5 14.5H4zM16 9a4.2 4.2 0 0 1 0 6M18.6 6.5a7.8 7.8 0 0 1 0 11',
  /* `Icons.live_tv_rounded`: a antena, a tela e o play dentro dela. */
  'tv-ao-vivo': 'M3 8.5h18V20H3zM8 8.5 12 4.5l4 4M10.5 12.2v4.6l4-2.3z',
  /* `Icons.sensors_rounded`: o ponto no meio e as ondas saindo dos dois lados. */
  sinal:
    'M12 13.2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4M8.5 15.5a5 5 0 0 1 0-7M15.5 8.5a5 5 0 0 1 0 7M5.7 18.3a9 9 0 0 1 0-12.6M18.3 5.7a9 9 0 0 1 0 12.6',
  /* `Icons.folder_open_rounded`: a pasta aberta das categorias. */
  pasta: 'M3 19V5.8h6L11 8h6.5v2.6M3 19h15.2l2.8-8.4H5.8z',
  /* `Icons.playlist_play_rounded`: as linhas da lista com o play no pé. */
  fila: 'M4 6.5h16M4 11h16M4 15.5h8M15 14.2v6l5-3z',
  /* `Icons.bookmark_border_rounded`: a fita da lista. */
  marcador: 'M7 4h10v16.5l-5-3.5-5 3.5z',
  /* `Icons.account_circle_outlined`. */
  conta:
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 12.2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM6.2 18.8a6.4 6.4 0 0 1 11.6 0',
  /* `Icons.search_off_rounded`: a lupa riscada de quem não achou nada. */
  'busca-cortada': 'M11 19a8 8 0 0 0 6.1-13.2M4.3 7.3a8 8 0 0 0 10.8 10.9M21 21l-4.3-4.3M3 3l18 18',
  /* `Icons.dns_rounded`: as duas gavetas empilhadas do servidor da casa. */
  servidor: 'M4 4.5h16v6H4zM4 13.5h16v6H4zM7.5 7.5v.01M7.5 16.5v.01',
  /* `Icons.chat_bubble_outline_rounded`: o balão da conversa passageira. */
  balao: 'M20 4.8H4v11.4h4.5V20l4.4-3.8H20z',
  /* `Icons.videocam_rounded`: a caixa da câmera com o bico apontando para fora. */
  camera: 'M4 6.5h11v11H4zM15 10.4 20 7.5v9l-5-2.9z',
  /* `Icons.videocam_off_rounded`: a mesma câmera, com o risco por cima. */
  'camera-cortada': 'M15 9.8V6.5H8.7M4 7.9v9.6h11v-1.3M15 10.4 20 7.5v9l-2.4-1.4M3 3l18 18',
  /* `Icons.mic_rounded`: a cápsula, o arco que a segura e o pé do pedestal. */
  microfone:
    'M12 14.6a3.1 3.1 0 0 0 3.1-3.1V6a3.1 3.1 0 0 0-6.2 0v5.5a3.1 3.1 0 0 0 3.1 3.1zM5.5 11a6.5 6.5 0 0 0 13 0M12 17.7V21M9 21h6',
  /* `Icons.mic_off_rounded`: o mesmo microfone de quem está sem som. */
  'microfone-cortado':
    'M15.1 6v5.5a3.1 3.1 0 0 1-5 2.5M8.9 10V6a3.1 3.1 0 0 1 5.5-2M5.5 11a6.5 6.5 0 0 0 10.9 4.8M18.5 11a6.5 6.5 0 0 1-.5 2.5M12 17.7V21M9 21h6M3 3l18 18',
  /* `Icons.call_end_rounded`: o fone deitado de quem desliga a chamada. */
  desligar: 'M3 13.4c5-4.6 13-4.6 18 0l-2.4 2.4-3.2-1.5v-2a11 11 0 0 0-6.8 0v2l-3.2 1.5z',
  /* `Icons.swap_horiz_rounded`: as duas setas de quem troca de servidor. */
  trocar: 'M4 8.5h13M14 5.5l3 3-3 3M20 15.5H7M10 12.5l-3 3 3 3',
  /* `Icons.fullscreen_rounded`: os quatro cantos do modo cinema. */
  'tela-cheia': 'M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5',
  /* `Icons.download_for_offline_rounded`: a seta para baixo dentro do círculo. */
  'baixar-circulo':
    'M12 3.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6M12 7.6v7M8.6 11.2 12 14.6l3.4-3.4',
  /* `Icons.source_rounded`: a pasta com a folha de dentro, a fonte do vídeo. */
  fonte: 'M3 19.5V5.5h5.6L10.4 8H21v11.5zM9.5 11.5h6M9.5 15h4',
  /* `Icons.layers_rounded`: as três camadas do "T1 E1". */
  camadas: 'm12 3.5 8.5 4.6-8.5 4.6-8.5-4.6zM3.5 12.6 12 17.2l8.5-4.6M3.5 16.6 12 21.2l8.5-4.6',
  /* `Icons.expand_more_rounded`: a seta que gira meia volta quando abre. */
  expandir: 'm6 9.5 6 6 6-6',
  /* `Icons.expand_less_rounded`: a mesma seta de cima para baixo. */
  recolher: 'm6 14.5 6-6 6 6',
  /* `Icons.list_rounded`: as três linhas com o pingo na frente. */
  lista: 'M8 7h12M8 12h12M8 17h12M4 7v.01M4 12v.01M4 17v.01',
  /* `Icons.checklist_rounded`: as duas linhas já riscadas — o desenho das
     listas que vêm da Alexa. */
  'lista-certa': 'M3 7.5 5.5 10 10 5.5M3 15.5 5.5 18 10 13.5M13 8h8M13 16h8',
  /* `Icons.playlist_add_check_rounded`: a lista com o certo na ponta de baixo. */
  'fila-certa': 'M4 6.5h16M4 11h16M4 15.5h8M13.5 18 16 20.5 21 15.5',
  /* `Icons.link_off_rounded`: os mesmos elos do `elo`, com o risco de quem
     desligou. */
  'elo-cortado':
    'M10.5 7.5H8a4.5 4.5 0 0 0 0 9h2.5M13.5 7.5H16a4.5 4.5 0 0 1 0 9h-2.5M9 12h6M3.5 3.5 20.5 20.5',
  /* `Icons.ios_share_rounded`: a caixa com a seta saindo por cima. */
  partilhar: 'M8 10H4.5v10.5h15V10H16M12 3.2v11.3M8.3 6.9 12 3.2l3.7 3.7',
  /* `Icons.check_circle_rounded`: o certo dentro do anel, do bloco de estado. */
  'certo-circulo': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12.2 11 15.2 16 9.2',
  /* `Icons.alternate_email_rounded`: o arroba do e-mail da conta. */
  arroba: 'M16 12a4 4 0 1 0-8 0 4 4 0 0 0 8 0M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.9 7.9',
  /* `Icons.edit_note_rounded`: as linhas com o lápis por cima, de quem pode
     mandar item para a Echo. */
  'nota-lapis': 'M3 6.5h13M3 11.5h8M3 16.5h6M13.5 20.5h2.6L21.5 15a1.9 1.9 0 0 0-2.6-2.6L13.5 18z',
  /* `Icons.visibility_rounded`: o olho de quem só consegue ler. */
  olho: 'M2.5 12a14 14 0 0 1 19 0 14 14 0 0 1-19 0M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6',
  /* `Icons.radio_button_unchecked_rounded`: o anel vazio do item por riscar. */
  radio: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17',
  /* `Icons.radio_button_checked`: o anel com o ponto cheio de quem está escolhido. */
  'radio-marcado':
    'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M12 10.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2',
  /* `Icons.tv_rounded`: a tela e o pé, para o selo de série. */
  tv: 'M3 5.5h18v11H3zM8.5 20.5h7',

  /* ── A biblioteca ────────────────────────────────────────────────────
     Os desenhos que só a estante usa. */

  /* `Icons.travel_explore_rounded`: o globo com a lupa, da busca que vai ao
     acervo inteiro em vez de só ao que já está na tela. */
  'busca-mundo':
    'M11 19a8 8 0 1 1 8-7.4M3.3 9h15.4M3.3 15h9.2M11 3a13 13 0 0 0 0 16 13 13 0 0 0 3.2-5.4M17.5 20.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M22 21.5l-2.7-2.7',
  /* `Icons.local_fire_department_rounded`: a chama do selo de "em alta". */
  chama:
    'M12 21c3.3 0 6-2.4 6-5.6 0-4.4-4-6.1-6-12.4-2 6.3-6 8-6 12.4C6 18.6 8.7 21 12 21zM12 21c1.7 0 3-1.2 3-2.8 0-2-2-2.9-3-5.1-1 2.2-3 3.1-3 5.1 0 1.6 1.3 2.8 3 2.8z',
  /* `Icons.emoji_events_rounded`: a taça do ranking da semana. */
  trofeu:
    'M8 3.5h8V9a4 4 0 0 1-8 0zM8 5H5.5v2A3.5 3.5 0 0 0 9 10.5M16 5h2.5v2a3.5 3.5 0 0 1-3.5 3.5M12 13v3.5M8.5 20.5h7l-1-4h-5z',
  /* `Icons.rocket_launch_rounded`: o foguete da ficção científica. */
  foguete:
    'M12 21c-1.6-1.6-2.5-3.6-2.5-6 0-4.5 1-8.1 2.5-12 1.5 3.9 2.5 7.5 2.5 12 0 2.4-.9 4.4-2.5 6zM9.5 12.5 6 15v4l3-2M14.5 12.5 18 15v4l-3-2M12 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3',
  /* `Icons.auto_awesome_motion_outlined`: as cartas empilhadas da poesia. */
  pilha:
    'M8.5 8.5h9.5a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H8.5a1 1 0 0 1-1-1V9.5a1 1 0 0 1 1-1zM6 5.5h10.5M4 3h9',
  /* `Icons.explore_rounded`: a bússola da aventura. */
  bussola: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M16 8l-2.2 5.8L8 16l2.2-5.8z',
  /* `Icons.brightness_3_rounded`: a lua minguante do terror. */
  lua: 'M20.8 14.4A9 9 0 0 1 9.6 3.2 9.1 9.1 0 1 0 20.8 14.4z',
  /* `Icons.picture_as_pdf_rounded`: a folha com o bloco, do formato PDF. */
  pdf: 'M5 3h9l5 5v13H5zM14 3v5h5M8 12.5h8v5H8z',
  /* `Icons.article_rounded`: a folha com as linhas, do formato de texto puro. */
  artigo: 'M5 3.5h14v17H5zM8 8h8M8 12h8M8 16h5',
  /* `Icons.phone_iphone_rounded`: o telefone do formato MOBI, que é de leitor. */
  celular: 'M7 2.5h10v19H7zM10.5 19.5h3',
  /* `Icons.language_rounded`: o globo do idioma e do formato HTML. */
  globo:
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M3.5 9h17M3.5 15h17M12 3a13 13 0 0 0 0 18 13 13 0 0 0 0-18',
  /* `Icons.headphones_rounded`: os fones dos audiolivros. */
  fones:
    'M4 15v-3a8 8 0 0 1 16 0v3M4 13.5h2.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM20 13.5h-2.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1H19a1 1 0 0 0 1-1z',
  /* `Icons.headset_off_rounded`: os mesmos fones riscados, de quando a busca
     de audiolivro não achou nada. */
  'fones-cortados':
    'M4 15v-3a8 8 0 0 1 12.2-6.8M20 12.2V15M4 13.5h2.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM20 13.5h-2.5a1 1 0 0 0-1 1v3.2M3 3l18 18',
  /* `Icons.auto_stories_rounded`: o livro aberto de páginas curvas, dos lidos.
     O `livro` é o `menu_book`, de canto reto: são dois desenhos diferentes. */
  'livro-aberto':
    'M12 7.8C10.2 6.2 7.9 5.4 5 5.4c-1 0-2 .1-2.9.3v12.6c.9-.2 1.9-.3 2.9-.3 2.9 0 5.2.8 7 2.4 1.8-1.6 4.1-2.4 7-2.4 1 0 2 .1 2.9.3V5.7c-.9-.2-1.9-.3-2.9-.3-2.9 0-5.2.8-7 2.4zM12 7.8V20.7',
  /* `Icons.share_rounded`: os três pontos ligados. O `partilhar` é o
     `ios_share`, com a seta para cima — a estante usa este. */
  'partilhar-pontos':
    'M18 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M6 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M18 20.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M8.2 10.8l7.6-4.1M8.2 13.2l7.6 4.1',
  /* `Icons.download_rounded`: a seta para a linha, de baixar o arquivo. */
  baixar: 'M12 3.5v11M7.5 10 12 14.5 16.5 10M4.5 19.5h15',
  /* `Icons.replay_rounded`: a volta ao contrário, de continuar lendo. */
  repetir: 'M4 12.5A8 8 0 1 0 6.4 6M4 4v4.5h4.5',
  /* `Icons.local_library_rounded`: a cabeça por cima do livro aberto, de
     "nenhum título parecido". É o `livro-aberto` com quem lê em cima. */
  biblioteca:
    'M12 8.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4M12 12.4C10.4 11 8.4 10.3 6 10.3c-1 0-2 .1-2.8.3v8c.9-.2 1.8-.3 2.8-.3 2.4 0 4.4.7 6 2.1 1.6-1.4 3.6-2.1 6-2.1 1 0 1.9.1 2.8.3v-8c-.9-.2-1.8-.3-2.8-.3-2.4 0-4.4.7-6 2.1zM12 12.4V20.4',

  /* ── O leitor ─────────────────────────────────────────────────────────
     Os quatro botões do rodapé e os dois do tamanho da letra. Os triângulos
     nascem na mesma altura do `tocar` para o rodapé não desalinhar. */

  /* `Icons.skip_previous_rounded`: o capítulo de trás, a faixa de trás. A
     barrinha com o triângulo é o desenho de *trocar de faixa* em todo tocador
     do mundo -- por isso ele é dos botões que trocam de faixa, e não dos de
     correr quinze segundos, que têm os dois triângulos logo abaixo. */
  'pular-atras': 'M6 5.4v13.2M18 5.4v13.2L7.4 12z',
  /* `Icons.skip_next_rounded`: o espelho do `pular-atras`. */
  'pular-adiante': 'M18 5.4v13.2M6 5.4v13.2L16.6 12z',
  /* `Icons.fast_rewind_rounded`: dois triângulos, sem barra. É o desenho de
     *correr dentro da mesma faixa* -- o que o botão de -15s faz. O nome vem do
     `correr()` do tocador, que é o método que ele chama. */
  'correr-atras': 'M21 5.4v13.2L12.4 12zM11.6 5.4v13.2L3 12z',
  /* `Icons.fast_forward_rounded`: o espelho do `correr-atras`. */
  'correr-adiante': 'M3 5.4v13.2L11.6 12zM12.4 5.4v13.2L21 12z',
  /* `Icons.stop_rounded`: o quadrado de cantos moles, de parar a leitura em
     voz alta. */
  parar:
    'M7.5 6h9a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6z',
  /* `Icons.text_decrease_rounded`: o A com o menos do lado. */
  'letra-menor': 'M3.5 18 8 6l4.5 12M5.3 14h5.4M15 12h6',
  /* `Icons.text_increase_rounded`: o mesmo A, com o mais. */
  'letra-maior': 'M3.5 18 8 6l4.5 12M5.3 14h5.4M15 12h6M18 9v6',

  /* ── O audiolivro ─────────────────────────────────────────────────────
     `Icons.graphic_eq_rounded`: as cinco barras do equalizador, que marcam
     qual faixa está tocando. As barras do Material ficam em 4, 8, 12, 16 e
     20; a do meio vai de 2 a 22 lá e aqui encolhe um a cada ponta, senão a
     ponta redonda do traço passa da caixa. */
  onda: 'M4 10v4M8 6v12M12 3v18M16 6v12M20 10v4',

  /* ── O quadro ─────────────────────────────────────────────────────────
     `Icons.brush_rounded`: o cabo em diagonal e a cerda no pé, que é o
     atalho do quadro no painel. */
  pincel:
    'M15.5 3.5a2.1 2.1 0 0 1 3 3L11 14l-3-3zM8 11l-1.2 1.2A3.5 3.5 0 0 0 4 15.5C4 17 3 18 2.5 18.5c1 1 2.5 1.5 4 1.5a3.5 3.5 0 0 0 3.5-3.5c0-1 .4-2 1.2-2.8z',
  /* `Icons.auto_fix_normal_rounded`: a varinha da borracha, com as duas
     faíscas que o Material põe em cima. */
  borracha:
    'm13.5 6.5 4 4L8 20H4v-4zM11.5 8.5l4 4M6 3l.8 1.9L8.7 5.7 6.8 6.5 6 8.4 5.2 6.5 3.3 5.7l1.9-.8z',
  /* `Icons.text_fields_rounded`: o T grande com o t pequeno do lado. */
  texto: 'M3 6h9M7.5 6v12M13.5 10.5h7M17 10.5V18',
  /* `Icons.undo_rounded`: a seta que volta por cima da curva. */
  desfazer: 'M8.5 7 5 10.5 8.5 14M5 10.5h8a4.5 4.5 0 0 1 0 9h-2',
  /* `Icons.redo_rounded`: a mesma, espelhada. */
  refazer: 'M15.5 7 19 10.5 15.5 14M19 10.5h-8a4.5 4.5 0 0 0 0 9h2',

  /* ── As finanças ──────────────────────────────────────────────────────
     `Icons.account_balance_rounded`: o telhado do banco, as três colunas e o
     chão. É o mesmo desenho do atalho e o do selo do cabeçalho. */
  banco: 'M3 9.5 12 4l9 5.5M6.5 12v6M12 12v6M17.5 12v6M4 20.5h16',
  /* `Icons.vpn_key_outlined`: a chave que falta no servidor. O `tranca` é o
     cadeado de trancar o aparelho — são dois desenhos diferentes. */
  chave: 'M7.5 14.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M7.5 11h.01M11 11h10M17 11v3M20.5 11v2',
  /* `Icons.science_outlined`: o frasco do laboratório, que marca o número de
     mentira do sandbox do Sicredi. */
  frasco: 'M9.5 3v6l-5.2 9a1.8 1.8 0 0 0 1.6 2.8h12.2a1.8 1.8 0 0 0 1.6-2.8l-5.2-9V3M8 3h8M7 14h10',

  /* ── As cartas ────────────────────────────────────────────────────────
     `Icons.mail_outline_rounded`: o envelope fechado, com a aba ainda por
     cima. É a carta que ninguém abriu. */
  carta: 'M3.5 6.5h17v11h-17zM3.5 7.5 12 13.2l8.5-5.7',
  /* `Icons.drafts_outlined`: o mesmo envelope com a aba levantada. É a carta
     já lida — no Flutter é ele que troca de lugar com o coração cheio. */
  'carta-aberta': 'M3 9.5 12 4l9 5.5V19H3zM3 9.5 12 15l9-5.5',

  /* ── Os calendários ───────────────────────────────────────────────────
     `Icons.edit_calendar_rounded`: o calendário com o lápis no canto de
     baixo, que é o calendário escrito aqui dentro e não assinado de fora.
     A moldura abre no canto de baixo à direita justamente para o lápis
     caber: é assim que o Material desenha. */
  'calendario-lapis':
    'M20 11.5V6H4v15h7M4 10.5h9M8.5 3v4M15.5 3v4M13 21h2.5L21.5 15a1.3 1.3 0 0 0-2-2L13 19.5z',

  /* ── O Kovu ───────────────────────────────────────────────────────────
     `Icons.wb_twilight_rounded`: o sol pela metade em cima da linha do
     horizonte, com os raios em volta. É o selo do "Kovu Hoje". */
  amanhecer:
    'M3.5 18.5h17M7.5 15.5a4.5 4.5 0 0 1 9 0M12 4.5v2M6.2 6.9 7.6 8.3M17.8 6.9 16.4 8.3M3.5 13.2h2M18.5 13.2h2',
  /* `Icons.psychology_rounded`: a cabeça com o pensamento enrolado dentro.
     Lá é um perfil com o cérebro desenhado; aqui, com um traço só, a cabeça
     fica redonda e o que sobra é o rabisco — que é o que se lê mesmo. */
  mente: 'M12 3.6a8.4 8.4 0 0 0 0 16.8 8.4 8.4 0 0 0 0-16.8M12 7.4a3 3 0 0 0 0 6 2 2 0 0 1 0 4',
  /* `Icons.quiz_rounded`: a carta de pergunta, com a interrogação no meio. */
  quiz: 'M5.5 3.5h13a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2M9.6 9.4a2.6 2.6 0 0 1 4.9-1.2c.6 1.2-.2 2.1-1.1 2.7-.9.6-1.4 1.2-1.4 2.9M12 16.6v.01',
  /* `Icons.push_pin_rounded` e `Icons.push_pin_outlined`: o percevejo que
     prende a memória no alto da lista. Como no resto da casa, o par cheio e
     vazio do Material vira um desenho só — quem diz se está preso é a cor. */
  alfinete: 'M9 3.5h6M10.2 3.5v5.8L7.4 12.7h9.2L13.8 9.3V3.5M12 12.7v7.8',
  /* `Icons.spa_outlined`: a flor da memória solta, a que ninguém prendeu. */
  flor: 'M12 4.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4M12 12.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4M4.8 12a3.2 3.2 0 1 0 6.4 0 3.2 3.2 0 0 0-6.4 0M12.8 12a3.2 3.2 0 1 0 6.4 0 3.2 3.2 0 0 0-6.4 0M12 10.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6',
  /* `Icons.cancel_rounded`: a roda com o xis, que marca a resposta errada no
     quiz. O círculo é o mesmo do `erro` de propósito. */
  'xis-circulo': 'M12 3.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6M9 9l6 6M15 9l-6 6',

  /* ── Os ajustes ───────────────────────────────────────────────────────
     `Icons.logout_rounded`: a porta aberta com a seta saindo dela. O
     `desligar` que já existia é o `call_end` — um telefone no gancho —, e
     usá-lo para "Sair" era pedir para alguém ler a coisa errada. */
  sair: 'M14.5 3.5H6a1.5 1.5 0 0 0-1.5 1.5v14A1.5 1.5 0 0 0 6 20.5h8.5M16 8.5l3.5 3.5-3.5 3.5M19.5 12H10',
  /* `Icons.palette_rounded`: a paleta de pintura, com os furos das tintas.
     A boca à direita é onde o polegar entra — é o que a faz ser paleta e
     não um prato. */
  paleta:
    'M12 3.6a8.4 8.4 0 0 0 0 16.8c1.1 0 1.9-.8 1.9-1.8 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.2 0-1 .8-1.8 1.9-1.8h2.2a3.4 3.4 0 0 0 3.4-3.4c0-4-3.8-7.4-8.4-7.4M7.6 11.4v.01M10 7.8v.01M14 7.8v.01M16.6 11v.01',
  /* `Icons.notifications_active_rounded`: o sino com as duas ondinhas de
     quem está tocando agora. */
  sino: 'M6.5 16.5V11a5.5 5.5 0 0 1 11 0v5.5h1.3H5.2zM10.2 19.5a2 2 0 0 0 3.6 0M3.4 8.2A6.3 6.3 0 0 1 5.9 4M20.6 8.2A6.3 6.3 0 0 0 18.1 4',
  /* `Icons.notifications_off_rounded`: o mesmo sino com o corte por cima. */
  'sino-cortado':
    'M6.5 16.5V11a5.5 5.5 0 0 1 8.2-4.8M17.5 12.6V16.5h1.3H5.2M10.2 19.5a2 2 0 0 0 3.6 0M4 4l16 16',
  /* `Icons.person_add_alt_rounded`: a pessoa com o mais ao lado, que entra
     na casa. */
  'pessoa-mais':
    'M9.5 4.2a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8M2.8 19.8c0-3.2 3-5.2 6.7-5.2 1.4 0 2.7.3 3.8.8M18 13.5v6M15 16.5h6',
  /* `Icons.person_remove_alt_1_rounded`: a mesma pessoa com o menos, que
     sai. */
  'pessoa-menos':
    'M9.5 4.2a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8M2.8 19.8c0-3.2 3-5.2 6.7-5.2 1.4 0 2.7.3 3.8.8M15 16.5h6',
  /* `Icons.fingerprint_rounded`: a digital, três arcos concêntricos e o
     miolo. Menos linhas que a do Material, porque a 17 pixels as de lá
     viram um borrão cinza. */
  digital:
    'M12 8.2a3.8 3.8 0 0 0-3.8 3.8v3.2M12 8.2a3.8 3.8 0 0 1 3.8 3.8c0 2.4-.3 4.3-.9 5.8M5.4 15.6c-.3-1.2-.4-2.4-.4-3.6a7 7 0 0 1 10.6-6M8.4 19.4c-.6-.9-1-1.9-1.3-3M12 12v4.5',
  /* `Icons.add_moderator_rounded`: o escudo com o mais dentro, que é criar
     uma chave nova neste aparelho. */
  'escudo-mais': 'M12 3.2 4.8 6v6c0 4.3 3 8.3 7.2 9.4 4.2-1.1 7.2-5.1 7.2-9.4V6zM12 9v6M9 12h6',
  /* `Icons.lock_open_rounded`: o mesmo cadeado do `tranca`, com o arco
     virado para o lado — é o que abre. */
  'tranca-aberta': 'M6 11h12v9H6zM9 11V8a3 3 0 0 1 5.9-.7',
  /* `Icons.volunteer_activism_rounded`: a mão erguida segurando o coração.
     É o "Esqueci meu código": só sai daqui com a ajuda de alguém da casa. */
  maos: 'M12 9.4S9.8 7.6 8.4 8.2a2 2 0 0 0-.6 3.2L12 15l4.2-3.6a2 2 0 0 0-.6-3.2c-1.4-.6-3.6 1.2-3.6 1.2M4.5 20.5v-5.2a1.5 1.5 0 0 1 3 0v.9h4.2a1.4 1.4 0 0 1 0 2.8h-1.6M19.5 20.5v-3.7',
  /* `Icons.sports_esports_rounded`: o controle de videogame da Zona de Jogos.
     O corpo é uma cápsula deitada; a cruzeta fica à esquerda e os dois botões
     à direita, que é como o desenho do Material se lê de longe. */
  controle:
    'M7.5 7.5h9a4.5 4.5 0 0 1 4.5 4.5c0 1.9-.6 4.5-3 4.5-1.5 0-2.2-1.2-3.4-1.2H9.4C8.2 15.3 7.5 16.5 6 16.5c-2.4 0-3-2.6-3-4.5a4.5 4.5 0 0 1 4.5-4.5M6.8 10.5v3M5.3 12h3M15.8 11.2v.01M17.8 13.2v.01',
  /* `Icons.sports_tennis_rounded`: a raquete de tênis de mesa, na diagonal, e
     a bolinha solta no canto de cima. */
  raquete:
    'M13.6 3.5a5.1 5.1 0 1 1 0 10.2 5.1 5.1 0 0 1 0-10.2M10 12.2 6.8 15.4a1.14 1.14 0 0 0 1.6 1.6l3.2-3.2M19.3 16.8v.01',
  /* `Icons.screen_rotation_rounded`: o aparelho pedindo para virar de lado.
     O retângulo em pé, o deitado atrás e a seta que gira de um para o outro. */
  girar:
    'M9.5 3.5h5a1.5 1.5 0 0 1 1.5 1.5v14a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 19V5a1.5 1.5 0 0 1 1.5-1.5M4.7 8.6A7.6 7.6 0 0 0 3.5 12M3 8.2l1.7.4.4-1.7M19.3 15.4A7.6 7.6 0 0 0 20.5 12M21 15.8l-1.7-.4-.4 1.7',

  /* ── A vitrola ────────────────────────────────────────────────────────
     `Icons.music_note_rounded`: a colcheia. A cabeça é uma roda cheia no
     Material; aqui vira um contorno, como todo o resto do arquivo. O
     `onda` — que é o `graphic_eq` do audiolivro — continua servindo às
     barrinhas de "está tocando"; esta é a que diz "música" parada. */
  'nota-musical': 'M9.5 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M12 17.5V4.2c3.2.6 5 2.2 5 4.6',
  /* `Icons.shuffle_rounded`: as duas linhas que se cruzam e terminam em
     seta, do sorteio. As pontas ficam à direita porque é para onde o
     sorteio leva: para o que vem a seguir. */
  embaralhar:
    'M4 7h2.8c1.5 0 2.6.8 3.6 2.2l3.2 5.6c1 1.4 2.1 2.2 3.6 2.2H20M4 17h2.8c1.5 0 2.6-.8 3.6-2.2l3.2-5.6c1-1.4 2.1-2.2 3.6-2.2H20M17.5 4.5 20 7l-2.5 2.5M17.5 14.5 20 17l-2.5 2.5',
  /* `Icons.leaderboard_rounded`: as três barras dos mais tocados, a do meio
     mais alta. Sem linha de base, como no Material — o chão delas é a linha
     do texto que vem embaixo. */
  podio: 'M6.5 20.5v-6.5M12 20.5v-14M17.5 20.5v-10',
  /* `Icons.history_rounded`: o relógio com a volta por fora e o canto que
     diz para que lado ela vai. O `relogio` sozinho é "que horas são"; este
     é "o que já passou". */
  historico: 'M3.5 12a8.5 8.5 0 1 0 3-6.5M3.5 8.2V12h3.8M12 7.4v4.8l3.4 2',
  /* `Icons.military_tech_rounded`: a medalha do pódio, com as duas fitas em
     cima. O miolo é um anel e não uma estrela: aos 10 px do selo de posição
     uma estrela dentro de um círculo vira borrão. */
  medalha:
    'M9 3.2v5.4M15 3.2v5.4M12 21a5.7 5.7 0 1 0 0-11.4 5.7 5.7 0 0 0 0 11.4M12 18.1a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6',
  /* `Icons.bolt_rounded`: o raio do selo de nível. O `brilho` é "isto foi
     gerado"; este é "isto é energia", e são coisas diferentes na mesma tela —
     o selo de nível e o atalho de "Today" ficariam com o mesmo desenho. */
  raio: 'M13 3 5.5 13.5H11L10 21l7.5-10.5H12z',
  /* `Icons.timeline_rounded`: os quatro pontos do zigue-zague, com o traço
     entre eles cortado antes de cada um. O `historico` é o relógio de "o que
     já passou"; este é a linha em que as coisas se põem em ordem. */
  'linha-do-tempo':
    'M5.6 15.9 7.9 13.6M11.1 13.6 12.9 15.4M15.5 15 19 8.5M4 19.1a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M9.5 13.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M14.5 18.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M20 8.1a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2',

  /* Os corredores do mercado e as refeições do dia. No Flutter cada um é um
     emoji (`🥬`, `🥩`, `🥖`, `🧀`, `🥫`, `🧊`, `🧃`, `🧽`, `🧴`, `🛒`, `☕`,
     `🍽️`, `🥪`, `🌙`), e três motivos tiraram o emoji daqui: a casa não põe
     emoji em tela, o mesmo cabeçalho de corredor aparece em quatro telas com
     tintas diferentes e o emoji não aceita tinta, e metade desses símbolos é
     de bloco Unicode novo — num Android velho eles saem como quadradinho. O
     desenho sai sempre igual em todo aparelho.

     `outros` reaproveita o `carrinho`, `almoço` o `comida` e `jantar` a `lua`,
     que já existiam: só o que não tinha traço ganhou um. */
  folha:
    'M20.5 3.5c.6 10.5-4 17-9.5 17a7.5 7.5 0 0 1-.6-15c3.9-.3 7-.8 10.1-2M7 18C9 12 13.5 7.5 19 5',
  /* O açougue e a peixaria: o peixe, com a cauda à esquerda e o olho.
     Chama-se `peixe` e não `carne` porque é um peixe: o corredor é o das duas
     coisas, e das duas o peixe é a que sobrevive ao tamanho. Um corte de carne
     em traço vira uma rosquinha, e uma coxa vira um pirulito — os dois foram
     desenhados e os dois foram lidos errado na folha de prova. */
  peixe:
    'M21 12c-2.6 3.6-5.9 5.4-9.9 5.4-2.7 0-4.9-1.8-4.9-5.4s2.2-5.4 4.9-5.4c4 0 7.3 1.8 9.9 5.4zM6.2 8.6 2.6 6.4v11.2l3.6-2.2M17.4 10.6v.01',
  /* A padaria: o pão de forma, com a primeira fatia cortada.
     A baguete deitada na diagonal também foi desenhada e virou um curativo, e
     com as pontas afiadas virou uma folha. A forma tem silhueta própria: o
     `sanduiche` é feito de três peças soltas empilhadas, e este é um contorno
     só, com o corte da fatia por dentro. */
  pao: 'M3.5 11.5a8.5 5.5 0 0 1 17 0v6.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2zM8.4 6.6V20',
  /* Laticínios e ovos: a caixa de leite. O queijo com furos, do emoji, some
     aos 16 px de um cabeçalho de grupo; a caixa continua legível. */
  leite: 'M7 21V8.5l2.5-3.5V3h5v2l2.5 3.5V21zM7 8.5h10M9.5 5h5M10 12.5h4',
  /* Mercearia: a lata em pé, com a tampa e a cinta do rótulo. */
  lata: 'M5.5 6.5c0-1.4 2.9-2.5 6.5-2.5s6.5 1.1 6.5 2.5v11c0 1.4-2.9 2.5-6.5 2.5s-6.5-1.1-6.5-2.5zM5.5 6.5c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5M8.5 12h7M8.5 15h7',
  /* Congelados: o floco de três eixos com as farpas em cima e embaixo. */
  floco:
    'M12 2.5v19M3.8 7.2l16.4 9.6M20.2 7.2 3.8 16.8M9.3 4.8 12 7.4l2.7-2.6M9.3 19.2 12 16.6l2.7 2.6',
  /* Bebidas: a garrafa de ombro, com a cinta do rótulo. */
  garrafa:
    'M9.5 3h5v3.2l2.4 3.2a3 3 0 0 1 .6 1.8V19a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-7.8a3 3 0 0 1 .6-1.8L9.5 6.2zM6.5 13.5h11',
  /* Limpeza: o borrifador, com o bico virado para a esquerda e o jato saindo.
     Os três pingos do jato são o que separa este do `sabonete` aos 18 px de um
     cabeçalho: sem eles os dois são o mesmo frasco, e o bico torto sozinho some
     nesse tamanho. */
  borrifador:
    'M8 10.5h8v9a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 19.5zM8 14h8M10.5 10.5V8h3v2.5M13.5 8h-4l-2-2M5.6 4.4v.01M4.2 5.7v.01M6.9 2.9v.01',
  /* Higiene: o frasco de bomba. O bico reto e alto separa este do `borrifador`,
     que tem bico torto e jato — os dois nunca aparecem no mesmo cabeçalho, mas
     aparecem um debaixo do outro na lista de compras. */
  sabonete:
    'M8 10h8v9.5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 19.5zM10.5 10V7h3v3M12 7V4.5h3.5M8 13.5h8',
  /* Café da manhã: a xícara com asa e as duas linhas de vapor. */
  xicara:
    'M4.5 8.5h12v6a6 6 0 0 1-12 0zM16.5 10.2h1.6a2.7 2.7 0 0 1 0 5.4h-1.6M4 20.5h13M8.5 3v2.6M12.5 3v2.6',
  /* Lanche: o pão de cima, o recheio e o pão de baixo. */
  sanduiche: 'M4 11a8 8 0 0 1 16 0zM3.5 14.2h17M4 17.4h16v1.4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z',
};
